import styled from 'styled-components';
import React from 'react';
import { Button, List, ListItem } from '../../components';
import TourSummary from './TourSummary';

type TourListProps = {
  tours: {
    id: string;
    name: string;
    date: Date;
    stops: {
      time?: Date;
      timeEnd?: Date;
    }[];
  }[];
  loading: boolean;
  onTourSelect: (tourId: string) => void;
};

const TourList: React.FC<TourListProps> = ({
  tours,
  loading,
  onTourSelect,
}) => (
    <>
      {(loading || tours.length > 0) && (
        <List
          split={false}
          dataSource={tours}
          loading={loading}
          renderItem={tour => (
            <StyledListItem>
              <Button
                data-cy={`toursFeature-tour-${tour.id}`}
                className={'TourItemCard'}
                onClick={() => onTourSelect(tour.id)}
              >
                <TourSummary {...tour} />
              </Button>
            </StyledListItem>
          )}
        />
      )}
    </>
  );

export default TourList;

const StyledListItem = styled(ListItem)`
  padding-top: 10px;
  padding-bottom: 0px;
  ${Button} {
    width: 100%;
    height: 84px;
    border-radius: 2px;
  }
  overflow: hidden;
`;
